import { User, UserSettings, UserTableLayoutSettings } from '../../../models/user.models';

export class GetUser {
  static type = '[User] Get';
}

export class UpdateUser {
  static type = '[User] Update';

  constructor(readonly update: Partial<User>) {}
}

export class GetUserSettings {
  static type = '[User] Get Settings';
}

export class ResendEmailVerification {
  static type = '[User] Resend Email Verification';
}

export class SetUserTableSettings {
  static type = '[User] Set table Settings';

  constructor(readonly tableLayout: Partial<UserTableLayoutSettings>) {}
}

export class SetUserSettings {
  static type = '[User] Set Settings';

  constructor(
    readonly updatedSettings: Partial<UserSettings>,
    readonly direct: boolean = true,
  ) {}
}

export class SetCOAToggle {
  static type = '[Customer] set COA Toggle';

  constructor(readonly value: boolean) {}
}

export class SetPgGoalsIncludePausedCampaignsInMetrics {
  static type = '[Customer] Set Pg Goals Include Paused Campaigns In Metrics';

  constructor(readonly value: boolean) {}
}
